import { EventEmitter } from "events"
import GhostContentAPI from '@tryghost/content-api'

class GhostService extends EventEmitter {
    constructor(Vue) {
        super()
        this.Vue = Vue
        this.api = new GhostContentAPI({
            url: process.env.VUE_APP_API_URL,
            key: process.env.VUE_APP_CONTENT_API_KEY,
            version: "v3"
        })
    }
    async getFAQsMeta(retry = 0) {
        try {
            let tags = await this.browseTags()
            tags = tags.filter(tag => tag.name.match(/^faq-[a-zA-Z0-9_.]+(-[a-zA-Z0-9_.])*/))
            if (process.env.NODE_ENV !== 'production') tags.map(tag => console.log('tag: ', tag.name, tag))
            this.meta = {
                categories: tags.map(tag => tag.slug.match(/-([a-zA-Z0-9_]+)(-[a-zA-Z0-9_])*$/) && tag.slug.match(/-([a-zA-Z0-9_]+)(-[a-zA-Z0-9_])*$/).length > 0 ? tag.slug.match(/-([a-zA-Z0-9_]+)(-[a-zA-Z0-9_])*$/)[1] : undefined)
                    .filter(tag => tag)
                    .sort()
                    .filter((item, pos, array) => !pos || item !== array[pos - 1]),
                subcategories: tags.map(tag => tag.slug.match(/-([a-zA-Z0-9_]+(-[a-zA-Z0-9_])*$)/) && tag.slug.match(/-([a-zA-Z0-9_]+(-[a-zA-Z0-9_])*$)/).length > 0 ? tag.slug.match(/-([a-zA-Z0-9_]+(-[a-zA-Z0-9_])*$)/)[1] : undefined)
                    .filter(tag => tag)
            }
            if (process.env.NODE_ENV !== 'production') console.log(this.meta);
            return this.meta
        } catch (error) {
            if (retry < 3) {
                retry += 1
                return this.getFAQsMeta(retry);
            }
        }
    }
    async getFAQs(category, subcategory, retry = 0) {
        try {
            let filter = category ? subcategory
                ? `tags:branfts-com+tags:faq-${category}-${subcategory}`
                : `tags:branfts-com+tags:faq-${category}`
                : `tag:branfts-com`
            let posts = await this.api.posts.browse({ filter })
            return posts.map(post => ({
                id: post.id,
                image: post.feature_image,
                q: post.title,
                a: post.html
            }))
        } catch (err) {
            if (retry < 3) {
                retry += 1
                return this.getFAQs(category, subcategory, retry);
            }
            console.error(err);
        }
    }
    async get(slug, retry = 0) {
        try {
            let post = await this.api.posts.read({ slug })
            return post
        } catch (error) {
            if (retry < 3) {
                retry += 1;
                return this.get(slug, retry);
            }
            console.error(error)
        }
    }
    async browseTags(filter, retry = 0) {
        try {
            let tags = await this.api.tags.browse({ filter })
            return tags
        } catch (error) {
            if (retry < 3) {
                retry += 1;
                return this.browseTags(filter, retry);
            }
            console.error(error)
        }
    }
}

export default (Vue) => new GhostService(Vue);